<template>
    <div>
        <div class="ui active loader" v-if="eventbus.print_label.is_processing">
            <div class="ui text loader">
                <!-- 載入標籤中 -->
                {{ $t('ui.general.initializing') }}
            </div>
        </div>
        <div v-else>
            <!-- 載入成功 -->
            <div v-if="eventbus.print_label.src">
                <div class="ui fluid button no border"
                    @click="$bus.$emit(eventbus.print_label.name)">
                    {{ $t('ui.toolbox.core_waybill.btns.'+((eventbus.print_label.is_force) ? 'print_again': 'print')) }}
                </div>
                <div style="position: relative;">
                    <img :src="eventbus.print_label.src">
                    <!-- <img
                        class="label_img"
                        :dataset-number="core_waybill.number"
                        :src="'data:image/png;base64,'+eventbus.print_label.src"
                        style="width: 100mm;height: 100mm;"> -->

                    <div
                        class="ui tiny icon button"
                        style="position: absolute;right: 0;bottom: 0;margin: 0;"
                        @click="$bus.$emit(eventbus.print_label.refetch_name)">
                        <i class="refresh icon"></i>
                    </div>
                </div>
            </div>
            <div v-else
                class="ui button no  border"
                :class="{orange: eventbus.print_label.status = 'failure'}"
                @click="$bus.$emit(eventbus.print_label.refetch_name)"
            >
                <i class="frown icon"></i>
                {{ eventbus.print_label.message }}
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },
        core_waybill: {
            default: {},
            type: Object
        },
        is_auto_print: {
            default: false,
            type: Boolean
        },
        is_can_print_label: {
            default: false,
            type: Boolean
        },
        is_enable_auto_print_label: {
            default: false,
            type: Boolean
        },
    },
    data() {
        return {
        }
    },
    created() {
    },
    mounted() {
    },
    computed: {
    },
    watch: {
    },
    methods: {
    },
}
</script>

<style scoped lang="scss">
</style>
